"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eqhi0tv0"
} : {
  target: "eqhi0tv0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "k7tw9m",
  styles: "display:grid;grid-row-gap:1.5em;&>div:last-of-type::after{display:none;width:5px;}"
} : {
  name: "k7tw9m",
  styles: "display:grid;grid-row-gap:1.5em;&>div:last-of-type::after{display:none;width:5px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});